import React from "react";
import { View, Grid, Card, useTheme, } from "@aws-amplify/ui-react";
import { useAuth0 } from "@auth0/auth0-react";


import MiniStatistics from "../../components/ministatics/MiniStatistics";

import "./Dashboard.css";
import TitleSection from "../../components/titlesection/TitleSection";
import Productivity from "../../components/Productivity/Productivity";
import { useMyContext } from "../../context/DataContext";
import { getDashboardDataApi } from "../../services/AxiosServices";
import { logError } from "../../utils/errorHandling";
const Dashboard = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { tokens } = useTheme();
  const { state } = useMyContext();
  const [data, setData] = React.useState<any>([])
  const fetchData = async () => {
    try {
      const token = await getAccessTokenSilently();
      const dashboardData = await getDashboardDataApi(state.bluePrint, token);
      setData(dashboardData)
    } catch (error) {
      logError("Dashboard data fetch failed", error);
    }
  }
  React.useEffect(() => {
    void fetchData()
  }, [state]);

  const label = data ? data?.productivity?.breakdown.map((item) => item.name) : [];
  const trafficSourceData = data ? data?.productivity?.breakdown.map((item) => item.value) : [];

  const productivityData = data ? {
    title: data?.productivity?.title,
    totalHours: parseFloat(data?.productivity?.hours_saved.match(/[\d.]+/)[0]).toString(),
    days: parseFloat(data?.productivity?.days_saved.match(/[\d.]+/)[0]).toString(),
    percentage: parseFloat(data?.productivity?.trend.match(/[\d.]+/)[0]).toString()
  } : {}

  const colors = ["#2d8bba", "#6ce5e8", "#38b6ff"]
  return (
    <>
      <TitleSection title="Dashboard" />
      <View borderRadius="6px" maxWidth="100%" padding="0rem" minHeight="100vh">
        <Grid
          templateColumns={{ base: "1fr", large: "1fr 1fr 1fr" }}
          templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
          gap={tokens.space.xl}
        >
          {
            data ? data?.metrics?.map((item, index) =>
              index <= 2 ?
                <View rowSpan={{ base: 1, large: 1 }} key={index}>
                  <MiniStatistics
                    title={item.title}
                    amount={item.value}
                    percentage={item.trend}
                    progress={item.change}
                    bgcolor={item.bgcolor}
                    textcolor={item.textcolor}
                  />
                </View>
                : null
            ) : null
          }
          <View columnSpan={[1, 1, 2]} rowSpan={{ base: 3, large: 4 }}>
            <Grid templateColumns={{ base: "1fr", large: "1fr 1fr" }} gap={tokens.space.xl}>
              {
                data ? data?.metrics?.map((item, index) =>
                  index > 2 ?
                    <View rowSpan={{ base: 1, large: 1 }} key={index}>
                      <MiniStatistics
                        title={item.title}
                        amount={item.value}
                        percentage={item.trend}
                        progress={item.change}
                        bgcolor={item.bgcolor}
                        textcolor={item.textcolor}
                      />
                    </View>
                    : null
                ) : null
              }
            </Grid>

            <Grid style={{ marginTop: 40 }} >
              <Productivity
                colors={colors}
                data={productivityData}
                label={label}
                trafficSourceData={trafficSourceData} />
            </Grid>
          </View>
          <View rowSpan={{ base: 1, large: 4 }}>
            <Card height="100%" borderRadius="15px" className="top-performer">
              <div className="card-title">Top Performers</div>
              <table>
                {
                  data ? data?.top_performers?.map((item, index) =>
                    <tr key={index}>
                      <td>
                        <div className="avatar">
                          <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/" + (index + 1) + ".png"}></img>
                        </div>
                      </td>
                      <td><span className="name">{item.name}</span></td>
                      <td><span className="hours">{item.hours}</span></td>
                    </tr>
                  )
                    : null
                }
              </table>
            </Card>
          </View>
        </Grid>
      </View>
    </>
  );
};

export default Dashboard;
